export function ErrorFallback({ error }: { error: Error }) {
  return (
    <div>
      <p>Sorry, we are having technical issues, please contact support.</p>
      <pre>{error.message}</pre>
    </div>
  )
}
